
export const initialValues = {
  productName: "",
  productCode: "",
  categoryId: "",
  activeStatus: 1,

}